<div *ngIf="this.getContentMst() as contentMsts" class="popup-wrapper">
  <div class="modal-header">
    <h5>
      <cbic-static-text [textEn]="popupTitle.En" [textHi]="popupTitle.Hi" class="modal-title"></cbic-static-text>
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modelRef.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body modal-dialog-scrollable custom-scroll-bar">
    <div *ngFor="let contentMst of contentMsts">
      <cbic-static-text [textEn]="contentMst.titleEn" [textHi]="contentMst.titleHi"></cbic-static-text>
      <br />
      <cbic-static-text [textEn]="contentMst.infoEn" [textHi]="contentMst.infoHi" [html]="true"></cbic-static-text>
      <div class="mb-3">
        <ul>
          <li *ngFor="let cbicInternal of contentMst.internalDocMappings">
            <ng-container *ngIf="this.flag.getLanguage() !== 'en'; else elseTemplate">
              <a
                *ngIf="cbicInternal.cbicDocMstDTO"
                [routerLink]=""
                class="tble_desc"
                (click)="ViewPdf(cbicInternal.cbicDocMstDTO.filePathHi)"
              >
                <cbic-static-text [textHi]="cbicInternal.cbicDocMstDTO.docTitleHi"></cbic-static-text>
                <span [ngClass]="utils.getDocumentIcon(cbicInternal.cbicDocMstDTO.docType)"></span
              ></a>
            </ng-container>
            <ng-template #elseTemplate>
              <a
                *ngIf="cbicInternal.cbicDocMstDTO"
                [routerLink]=""
                class="tble_desc"
                (click)="ViewPdf(cbicInternal.cbicDocMstDTO.filePathEn)"
              >
                <cbic-static-text [textEn]="cbicInternal.cbicDocMstDTO.docTitleEn" ></cbic-static-text>
                <span [ngClass]="utils.getDocumentIcon(cbicInternal.cbicDocMstDTO.docType)"></span
              ></a>
            </ng-template>
          </li>
        </ul>
      </div>
      <hr />
    </div>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-primary" text-align="center" (click)="modelRef.dismiss('Cross click')" alin>Ok</button>
  </div>
</div>
